/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Googleloading1Inputs */

const he_auth_login_googleloading1 = /** @type {(inputs: Auth_Login_Googleloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעביר ל-Google...`)
};

const en_auth_login_googleloading1 = /** @type {(inputs: Auth_Login_Googleloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting to Google...`)
};

/**
* | output |
* | --- |
* | "Redirecting to Google..." |
*
* @param {Auth_Login_Googleloading1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_login_googleloading1 = /** @type {((inputs?: Auth_Login_Googleloading1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Googleloading1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_login_googleloading1(inputs)
	return en_auth_login_googleloading1(inputs)
});
export { auth_login_googleloading1 as "auth_login_googleLoading" }